(function() {
  'use strict';

  // ── Bundle Module: show more ──

  var moreBtn = document.querySelector('[data-bundle-more]');
  if (moreBtn) {
    var extraItems = document.querySelectorAll('.product__bundle-item--extra');
    moreBtn.addEventListener('click', function() {
      var isOpen = this.classList.toggle('is-open');
      extraItems.forEach(function(el) {
        el.style.display = isOpen ? 'flex' : 'none';
        if (isOpen) el.classList.add('is-visible'); else el.classList.remove('is-visible');
      });
      var textEl = this.querySelector('span');
      if (textEl) textEl.textContent = isOpen ? 'Show Less' : 'Show More';
    });
  }

  // ── Bundle + Warranty: intercept ADD TO CART and BUY IT NOW ──
  var productForm = document.querySelector('form[action*="/cart/add"]');
  if (!productForm) productForm = document.getElementById('ProductForm-Main');
  if (!productForm) productForm = document.querySelector('[data-product-form]');

  if (productForm) {
    function collectExtras() {
      var extras = [];
      document.querySelectorAll('.product__bundle-checkbox-input:checked').forEach(function(cb) {
        var vid = cb.getAttribute('data-variant-id');
        if (vid) extras.push({ id: parseInt(vid, 10), quantity: 1 });
      });
      var wr = document.querySelector('.product__warranty-radio:checked');
      if (wr && wr.value) extras.push({ id: parseInt(wr.value, 10), quantity: 1 });
      return extras;
    }

    function getMainItem() {
      var fd = new FormData(productForm);
      return { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity'), 10) || 1 };
    }

    function addAllToCart(items, cb) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.status && data.status !== 200) throw new Error(data.description || 'Error');
        cb(null, data);
      })
      .catch(function(err) { console.warn('Bundle cart error:', err); cb(err); });
    }

    function updateCartCount() {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      });
    }

    function openCartDrawer() {
      var d = document.getElementById('cart-drawer');
      if (d) {
        d.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cart-drawer-open');
        document.dispatchEvent(new CustomEvent('cart:open'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } else {
        var t = document.querySelector('[data-cart-toggle], [aria-controls="cart-drawer"], .header__cart');
        if (t) t.click();
      }
    }

    // Intercept ADD TO CART click (capture phase → runs before theme JS)
    var addBtn = productForm.querySelector('[data-add-to-cart]');
    if (addBtn) {
      addBtn.addEventListener('click', function(e) {
        var extras = collectExtras();
        if (extras.length === 0) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var origText = addBtn.textContent.trim();
        addBtn.textContent = 'ADDING…'; addBtn.disabled = true;
        addAllToCart([getMainItem()].concat(extras), function(err) {
          if (err) { addBtn.textContent = origText; addBtn.disabled = false; return; }
          addBtn.textContent = '✓ ADDED!'; addBtn.disabled = false;
          setTimeout(function() { addBtn.textContent = origText; }, 2500);
          updateCartCount();
          openCartDrawer();
        });
      }, true);
    }

    // Intercept BUY IT NOW click
    var buyBtn = productForm.querySelector('.product__buy-now-btn, [name="checkout"]');
    if (buyBtn) {
      buyBtn.addEventListener('click', function(e) {
        var extras = collectExtras();
        if (extras.length === 0) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var origText = buyBtn.textContent.trim();
        buyBtn.textContent = 'PROCESSING…'; buyBtn.disabled = true;
        addAllToCart([getMainItem()].concat(extras), function(err) {
          if (err) { buyBtn.textContent = origText; buyBtn.disabled = false; return; }
          window.location.href = '/checkout';
        });
      }, true);
    }

    // Fallback: also intercept native form submit
    productForm.addEventListener('submit', function(e) {
      var extras = collectExtras();
      if (extras.length === 0) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addAllToCart([getMainItem()].concat(extras), function(err) {
        if (err) return;
        updateCartCount();
        openCartDrawer();
      });
    }, true);
  }

  // ── Warranty: allow deselect by re-clicking ──
  document.querySelectorAll('.product__warranty-option').forEach(function(label) {
    label.addEventListener('click', function(e) {
      var radio = this.querySelector('.product__warranty-radio');
      if (!radio) return;
      if (radio.checked && radio.dataset._wasChecked === 'true') {
        e.preventDefault(); radio.checked = false; radio.dataset._wasChecked = 'false';
      }
    });
    var radio = label.querySelector('.product__warranty-radio');
    if (radio) {
      radio.addEventListener('change', function() {
        document.querySelectorAll('.product__warranty-radio').forEach(function(r) { r.dataset._wasChecked = 'false'; });
        if (this.checked) this.dataset._wasChecked = 'true';
      });
    }
  });

  // ── Warranty popup modal ──
  var warrantyPopupBtn = document.querySelector('[data-warranty-popup]');
  var warrantyModal = document.getElementById('warranty-modal');
  if (warrantyPopupBtn && warrantyModal) {
    warrantyPopupBtn.addEventListener('click', function() {
      warrantyModal.hidden = false;
      document.body.style.overflow = 'hidden';
    });
    warrantyModal.querySelectorAll('[data-warranty-close]').forEach(function(el) {
      el.addEventListener('click', function() {
        warrantyModal.hidden = true;
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !warrantyModal.hidden) {
        warrantyModal.hidden = true;
        document.body.style.overflow = '';
      }
    });
  }

  // ── Accordion sections ──
  document.querySelectorAll('.product__accordion-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var isOpen = this.getAttribute('aria-expanded') === 'true';
      var body = this.nextElementSibling;
      if (!body) return;
      this.setAttribute('aria-expanded', String(!isOpen));
      body.hidden = isOpen;
    });
  });
})();